import React, { Component } from 'react';
import {
    AUTH_REQUESTS,
    msal,
    requiresInteraction,
    inFrame,
    returningFromLoginRedirect,
    buildAuthority,
    buildForgotPasswordAuthority,
    ERR_USER_CANCELED,
    ERR_FORGOT_PASSWORD,
    parseError
} from '../lib/auth';
import api from '../lib/er-axios';

export default function AuthProvider(ComposedComponent) {
    return class extends Component {
        constructor(props) {
            super(props);
            this.state = {
                account: msal.getAccount(),
                api: null,
                error: null
            };
            this.accountID = null;
            this.userID = null;
        }

        async acquireToken(request) {
            return msal.acquireTokenSilent(request).catch(error => {
                    if (requiresInteraction(error.errorCode)) {
                        return msal.acquireTokenRedirect(request);
                    } else {
                        // console.error('Non-interactive error:', error.errorCode, error);
                    }
                });
        }

        async signIn(policy) {
            if (policy) {
                msal.authority = buildAuthority(policy);
            }
            return msal.loginRedirect(AUTH_REQUESTS.LOGIN);
        }

        forgotPassword() {
            msal.authority = buildForgotPasswordAuthority();
            return msal.loginRedirect(AUTH_REQUESTS.LOGIN);
        }

        signOut() {
            msal.logout();
        }

        async componentDidMount() {
            if (inFrame()) return;

            msal.handleRedirectCallback((error, response) => {
                if (error) {
                    const errorType = parseError(error);
                    switch (errorType) {
                        case ERR_USER_CANCELED:
                            window.history.pushState({}, '', '/login');
                            break;
                        case ERR_FORGOT_PASSWORD:
                            this.forgotPassword();
                            break;
                        default:
                            const errorMessage = 'An error occurred, please try again.';
                            this.setState({ error: errorMessage }, () => window.history.pushState({}, '', '/login'));
                    }
                } else {
                    this.accountID = response.idToken.claims.er_aid;
                    this.userID = response.idToken.claims.er_uid;
                }
            });

            const account = msal.getAccount();

            if (account) {
                const tokenRequest = this.acquireToken(AUTH_REQUESTS.TOKEN(this.accountID, this.userID));
                const tokenResponse = await tokenRequest;

                if (tokenResponse) {
                    this.setState({
                        account,
                        api: api(
                            tokenResponse.accessToken,
                            tokenRequest.catch(err => {
                                // console.error(err);
                                this.signOut();
                            })
                        )
                    });
                }
            } else if (!returningFromLoginRedirect) {
                const loginUrl = `/login`;
                if (!window.location.href.endsWith(loginUrl)) {
                    window.location.href = loginUrl;
                }
            }
        }

        render() {
            return (
                <ComposedComponent
                    {...this.props}
                    account={this.state.account}
                    api={this.state.api}
                    error={this.state.error}
                    signOut={() => this.signOut()}
                    signIn={this.signIn}
                />
            );
        }
    };
}



// WEBPACK FOOTER //
// ./src/components/AuthProvider.js